export default __webpack_public_path__ + "static/media/book14.f655c945.svg";